<template>

    <div class="form-draggable">
        <draggable :list="fields"
                   :clone="clone"
                   @end="onEnd"
                   v-bind="dropElementOptions"
                   class="elements"
                   ghost-class="ghost"
                   :group="{name:'fields' , pull: 'clone' , put: false}">
            <div class="element" v-for="(field,index) in fields">

                <div class="ix-formbuilder-component-picker" :key="index" v-if="field.type == type">
                    <span class="ix-drag-icon handle-line"></span>
                    <div class="ix-formbuilder-component-picker-icon">
                        <div class="ix-formbuilder-icon">
                            <i :class="field.icon"></i>
                        </div>
                    </div>
                    <div class="ix-formbuilder-component-picker-label">
                        {{ field.text }}
                    </div>
                </div>
                
            </div>
        </draggable>
    </div>
</template>

<script>

    import { FormBuilder } from "./formbuilder";
    import draggable from 'vuedraggable';

    export default {
        name: "Elements",
        store: ['forms' , 'activeForm' , 'element'],
        components : { draggable },
        props : ['filter'],
        data(){
            return {
                fields : FormBuilder.$data.fields,
                dropElementOptions: FormBuilder.$data.dropElementOptions,
                type : this.filter || 'data',
                currentField: null
            }
        },
        methods : {
            clone(field){
                let newField = {
                    component : field.component,
                    type : field.type,
                    value     : '',
                    helper    : ''
                }
                newField.label = field.text;

                if (field["required"] !== undefined) {
                    newField.required = false
                }

                if(field.component == 'TextComponent')
                    newField.inputType = 'text'

                if(field.component == 'NumberComponent'){
                    newField.min = '';
                    newField.max = '';
                    newField.step = 0.01;
                }    


                // Pour les types : radios-checkbox-select
                if (field.hasOptions){
                    newField.options = [
                        { value: "Option 1" },
                        { value: "Option 2" }
                    ]
                }

                // Pour les tableaux
                if(field.component == 'TableComponent'){
                    newField.position = 'horizontal';
                    newField.rows_count = 2;
                    newField.columns_count = 2;
                    newField.horizontal_labels =  ['',''],
                    newField.vertical_labels =  ['','']       
                       
                    newField.rows = new Array(2);
                    newField.rows[0] = ['' , ''];
                    newField.rows[1] = ['' , ''];
                }

                if(field.component == 'QuizzComponent'){
                    newField.labels = ['Très bien' , 'Bien' , 'Suffisant', 'Insuffisant'];
                    newField.displayObservation = true;
                    newField.grid = [
                        {
                            title : 'Thématique',
                            questions : [{
                                label : 'Question 1',
                                answers : newField.labels, 
                                value: '', 
                                observations : ''
                            }],
                            background: '#0f6674',
                            color: '#ffffff',
                            borderColor: '#0f6674',
                            textAlign: 'center'
                        },
                     
                    ];
                    newField.colspan = newField.displayObservation ? 2 + newField.labels.length : 1 + newField.labels.length

                }

                if(field.component == 'DatepickerComponent'){
                    newField.format = 'date';
                }


                if(field.component == 'ChartComponent'){
                    newField.chartType = 'Line'
                    newField.collections = {
                        labels: ['Titre 1'],
                        datasets: [
                            {
                                label: 'Série 1',
                                backgroundColor: '#f87979',
                                data: new Array(2)
                            }
                        ]
                    }
                }

                if(field.component == 'AppendicesComponent'){
                    newField.show_pdf = true;
                    newField.files = [];
                }

                if(field.component == 'TitleComponent'){
                    newField.font_size = 'large';
                    newField.font_weight = 'bold';
                } else if(field.component == 'ParagraphComponent'){
                  newField.label = 'Paragraphe'
                    newField.font_size = 'normal';
                    newField.font_weight = 'normal';
                } else {
                    newField.font_size = 'normal';
                    newField.font_weight = 'normal';
                }
                newField.font_color = '#000000';

                this.element.value = newField; 
                this.currentField = newField;
                return newField;
            },
            onEnd(field){
                if(field.from != field.to){
                    vm.$store.activeForm = this.currentField;
                    $('#propertiesModal').modal({'backdrop': 'static'})
                    $('#settings-tab').tab('show');
                }
            }
        },
    }
</script>

<style scoped>
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
</style>
